export default __webpack_public_path__ + "static/media/medina-pic.4e3b6391.png";